import React, { Component } from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import ReactDOMServer from 'react-dom/server';
import CopyToClipboard from 'react-copy-to-clipboard';

import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import Snackbar from 'material-ui/Snackbar';

import Control from './Control';
import { XmlRoot, Site, Node } from '../Xml';
import { ReplaceAll } from '../Util';

const replaceStrings = {
	'&lt;': '<',
	'&gt;': '>',
	'&quot;': '"'
}

class SiteGenerator extends Component {
	state = {
		showCopyMessage: false,
		site: {
			name: 'domain.ch',
			packageKey: 'Your.Website',
			nodeName: 'website'
		},
		rootNode: {
			nodeType: 'Your.Website:Homepage',
			title: 'Your Website',
			uriPathSegment: 'website'
		},
		dimensions: {
			language: 'de'
		}
	}

	handleSiteChange = (event) => {
		this.setState({
			site: {
				...this.state.site,
				[event.target.name]: event.target.value
			}
		});
	}

	handleRootNodeChange = (event) => {
		this.setState({
			rootNode: {
				...this.state.rootNode,
				[event.target.name]: event.target.value
			}
		});
	}

	handleDimensionChanges = (name, value) => {
		if (!value) { // delete
			this.setState({
				dimensions: omit(this.state.dimensions, [name])
			});
		} else { // add or update
			this.setState({
				dimensions: {
					...this.state.dimensions,
					[name]: value
				}
			});
		}
	}

	toggleCopiedMessage = () => {
		this.setState({
			showCopyMessage: !this.state.showCopyMessage
		});
	}

	render() {
		const { classes } = this.props;
		const XmlSite = (
			<XmlRoot>
				<Site name={this.state.site.name} packageKey={this.state.site.packageKey} nodeName={this.state.site.nodeName}>
					<Node
						nodeName={this.state.site.nodeName}
						nodeType={this.state.rootNode.nodeType}
						properties={{
							title: this.state.rootNode.title,
							uripathsegment: this.state.rootNode.uriPathSegment
						}}
						dimensions={this.state.dimensions}
						>
						<Node nodeName="main" nodeType="Neos.Neos:ContentCollection" dimensions={this.state.dimensions} />
					</Node>
				</Site>
			</XmlRoot>
		);

		return (
			<div>
				<Control
					site={this.state.site}
					rootNode={this.state.rootNode}
					dimensions={this.state.dimensions}
					onSiteChange={this.handleSiteChange}
					onRootNodeChange={this.handleRootNodeChange}
					onDimensionChange={this.handleDimensionChanges}
				/>

				<div className={classes.container}>
					<CopyToClipboard text={ReplaceAll(ReactDOMServer.renderToStaticMarkup(XmlSite), replaceStrings)} onCopy={this.toggleCopiedMessage}>
						<Button color="primary">Copy Site.xml</Button>
					</CopyToClipboard>
				</div>

				<section className={classes.code}>
					<pre>
						<code>
							{XmlSite}
						</code>
					</pre>
				</section>
				<Snackbar message="XML has been copied to the clipboard" open={this.state.showCopyMessage} autoHideDuration={5000} onClose={this.toggleCopiedMessage} />
			</div>
		);
	}
};

SiteGenerator.propTypes = {
	classes: PropTypes.object.isRequired
};

const styles = theme => ({
	container: {
		marginTop: theme.spacing.unit * 3
	},
	code: {
		marginTop: theme.spacing.unit * 5,
		overflow: 'hidden',
		overflowX: 'auto'
	}
});

export default withStyles(styles)(SiteGenerator);



// WEBPACK FOOTER //
// ./src/components/SiteGenerator/index.js